export const STRAPI_URL = 'https://adk-strapi-dev.i-taros.net';
export const TEMPLATES_URL = 'https://apiqs.i-taros.net/templates/generate/';

export const TEMPLATES_SERVICE_SERVER_ID = 'dev';
export const TEMPLATES_SERVICE_CLIENT_ID = 'client_F6wto_20240409141200452';
export const TEMPLATES_SERVICE_PASSWORD = 'strifeberserkers:A*x!~HZ5]V5PkdSx';
